import React, { useState, useEffect } from 'react';

import { 
  Resource
} from "@dndModels";

import API from "@dndUtilities/system_api";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import LoadingBox from "@components/input/LoadingBox";
import { DisablableOption } from "@models";

interface Props {
  name: string;
  value: string;
  onChange: (id: string) => void;
  uses_dice_only?: boolean;
  extra_options?: string[];
  disabled?: boolean;
}

const api = API.getInstance();

export default function SelectResourceBox({
  name,
  value,
  onChange,
  uses_dice_only = false,
  extra_options = [],
  disabled = false
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<DisablableOption[]>([]);
  // const [resources, setResources] = useState<Resource[]>([]);

  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  const load = () => {
    setLoading(true);
    setFetched(true);
    api.getObjects({data_type: "resource"}).then(res => {
      let new_resources = res as Resource[];
      const new_options: DisablableOption[] = extra_options.map(o => {
        const opt: DisablableOption = {
          id: o, text: o
        }
        return opt;
      });
      
      if (uses_dice_only) {
        new_resources = new_resources.filter(o => o.default_dice_size > 0);
      }
      new_resources.forEach(resource => {
        let text = resource.name;
        if (new_resources.filter(o => o.name === text).length > 1) {
          text += " (" + resource.description + ")";
        }
        new_options.push({ id: resource._id, text, disabled: false, reason: "" });
      });
      // setResources(new_resources);
      setOptions(new_options);
      setLoading(false);
    });
  }

  if (loading) {
    return (<LoadingBox />);
  } else {
    return (
      <SelectStringBox 
        options={options}
        value={value} 
        name={name}
        disabled={disabled}
        onChange={(id: string) => {
          onChange(id);
        }}
      />
    );
  }
}
